'use strict';

let btClientInstancePromise;
let venmoClientInstance;

/**
 * Checks whether browser supports Venmo
 * @returns {Promise} with isBrowserSupported value
 */
function isBrowserSupported() {
    return btClientInstancePromise
        .then(function(btClientInstance) {
            venmoClientInstance = btClientInstance;

            return braintree.venmo.isBrowserSupported({
                allowNewBrowserTab: false,
                allowDesktopWebLogin: true
            });
        });
}

/**
 * Creates Venmo instance
 * @param {boolean} isCustomerRegistered If customer is registered or not
 * @returns {Promise} Promise resolved with Venmo instance
 */
function createVenmo(isCustomerRegistered) {
    const venmoHelper = require('../helpers/venmoHelper');

    const isEnrichedCustomerDataEnabled = venmoClientInstance.getConfiguration().gatewayConfiguration.payWithVenmo.enrichedCustomerDataEnabled;

    venmoHelper.setEnrichedCustomerDataValue(isEnrichedCustomerDataEnabled);

    const options = {
        client: venmoClientInstance,
        allowNewBrowserTab: false,
        ignoreHistoryChanges: true,
        allowDesktopWebLogin: true,
        paymentMethodUsage: isCustomerRegistered ? 'multi_use' : 'single_use'
    };

    if (isEnrichedCustomerDataEnabled) {
        options.collectCustomerBillingAddress = true;
        options.collectCustomerShippingAddress = true;
    }

    return braintree.venmo.create(options);
}

/**
 * Tokenizes Venmo payment
 * @param {Object} venmoInstance Venmo instance
 * @returns {Promise} Promise resolved with tokenized payload
 */
function tokenize(venmoInstance) {
    return venmoInstance.tokenize({ processResultsDelay: 10 });
}

/**
 * Inits braintreeVenmoSDK with client instance promise
 * @param {Promise} braintreeClientInstancePromise Braintree Venmo client instance promise
 */
function init(braintreeClientInstancePromise) {
    btClientInstancePromise = braintreeClientInstancePromise;
}

module.exports = {
    init,
    isBrowserSupported,
    createVenmo,
    tokenize
};
